<template>
  <div class="fin-panel-body">
    <ol class="fin-steps">
      <li v-for="n in 3" :key="n">
        <span>
          <b>{{ $t(`finance_shell.how_to_pay.step${n}_title`) }}</b>
          {{ $t(`finance_shell.how_to_pay.step${n}`) }}
        </span>
      </li>
    </ol>
    <div class="ui-banner ui-banner--info ">
      <v-icon size="16" color="currentColor">mdi-information-outline</v-icon>
      <span>{{ $t("finance_shell.how_to_pay.note") }}</span>
    </div>
  </div>
</template>

<script>
/** Kako platiti kad restoran duguje Orderi: tri koraka (uplata, svrha, evidencija administratora). */
export default {
  name: "FinanceHowToPayPanel",
};
</script>
